import { gql } from '@apollo/client';

const UPSERT_AREA=gql`
mutation upsertArea ($input: ClubMateAreaMutationInput!) {
  clubmate {
    upsertClubmatearea(input: $input) {
      clubMateArea{
        id
        coordinate
        isAlias
        name
      }
      errors{
        messages
      }
    }
  }
}
`

const DELETE_AREA = gql`
mutation deleteArea ($id:ID!){
  clubmate {
    deleteClubmatearea (id:$id){
      message
      ok
    }
  }
}
`

const UPSERT_TRACK_AREA=gql`
mutation TrackArea($id:bigint!,$coordinates:geometry){
  update_clubmate_clubmatearea_clubmatearea_by_pk(pk_columns: {id: $id}, _set: {coordinate:$coordinates}){
       id
  }
}
`

const GET_HOME=gql` 
query GetHome($id:Int!){
  clubmate{
    areaclubmate(id:$id){
      id
      homeCoordinates
      recursiveHomeCoords
      name
      type {
        id
      }
      coordinates
      color
    }
  }
}`

const GET_POLYGON=gql`
query MyQuery ($id:bigint!) {
  clubmate_clubmatearea_clubmatearea_by_pk(id: $id) {
    coordinate
  }
}
`

export {UPSERT_AREA, DELETE_AREA, UPSERT_TRACK_AREA, GET_HOME, GET_POLYGON}